import { render, staticRenderFns } from "./po_ask.vue?vue&type=template&id=f2fd558c&scoped=true&"
import script from "./po_ask.vue?vue&type=script&lang=js&"
export * from "./po_ask.vue?vue&type=script&lang=js&"
import style0 from "./po_ask.vue?vue&type=style&index=0&id=f2fd558c&scoped=true&lang=less&"
import style1 from "./po_ask.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fd558c",
  null
  
)

export default component.exports